import { render, staticRenderFns } from "./ResidentList.vue?vue&type=template&id=0218bd3e"
import script from "./ResidentList.vue?vue&type=script&lang=js"
export * from "./ResidentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports